export default __webpack_public_path__ + "static/angus-e8b88296efd59ed91943e834ba8560e6.png";